import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import "./loading-dots.scss";

const LoadingDots = ({ className, ...props }) => {
  const classes = classnames("loading-dots", className);
  return (
    <div className={classes} {...props}>
      <div className="loading-dot" />
      <div className="loading-dot" />
      <div className="loading-dot" />
      <div className="loading-dot" />
    </div>
  );
};

LoadingDots.propTypes = {
  /**
   * Optional className to append to the outer container
   */
  className: PropTypes.string,
};

export default LoadingDots;
